export default "__VITE_ASSET__BLFoj69e__"